import { motion } from "framer-motion";
import { useEffect } from "react";

import ManagementCertification from "../../../components/management_certification";
import WhyWorkWithUS from "../../../components/whyWorkWithUs";
import { servicesCategory } from "../../../utilities/serviceData";
import GlobalBanner from "../../../components/banner";
import EndingBanner from "../../../components/endingBanner";
import { useNavigate } from "react-router-dom";

import DefaultPadding from "../../../utilities/constants";
import bannerImg from "../../../assets/service/images/bannerImg.jpg";

const ServicePage = () => {
  useEffect(() => {
    document.title = "Services";
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const navigate = useNavigate();

  const services = [];

  servicesCategory.forEach((_item, _index) => {
    _item.child.forEach((item, idx) => {
      services.push({ ...item, name: _item.name });
    });
  });

  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();

  return (
    <main>
      <GlobalBanner bannerImg={bannerImg}>
        <span className="font-semibold text-visOrange"> Our Services</span>
      </GlobalBanner>
      <section
        className={`${defaultPaddingX} flex flex-col gap-5 py-10 text-center`}
      >
        {/* <h1 className="text-2xl font-semibold text-[#332C47] md:text-4xl">
          Explore Top Notch Solutions and Services
        </h1> */}
        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-10 lg:grid-cols-3">
          {services.map((item, index) => {
            return (
              <motion.div
                key={index}
                whileHover={{
                  scale: 1.05,
                  backgroundColor: "#1F3B7D",
                  border: "1px solid #1F3B7D",
                  color: "white",
                  transition: { type: "spring", stiffness: 150, duration: 0.1 },
                }}
                className="col-span-1 flex h-full cursor-pointer flex-col overflow-hidden rounded-sm border px-3 py-10 shadow-visCardShadow"
                onClick={() => {
                  navigate(`/services/detail/${item.href}`);
                }}
              >
                <div className="flex flex-1 flex-col items-center gap-2">
                  <img className="h-16 w-16" src={item.icon} alt="" />
                  <h2 className="mt-2 text-2xl font-semibold">{item.label}</h2>
                </div>
                <div className="flex flex-1 flex-col items-center gap-2">
                  <hr className="mb-3 mt-6 w-[80%] border" />
                  <p className="text-center">{item.discription}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      <section className={`${defaultPaddingX} bg-visBlue py-16`}>
        <WhyWorkWithUS />
      </section>
      <section className={`${defaultPaddingX} flex flex-col gap-12 py-16`}>
        <ManagementCertification title={"We Are ISO Certified"} />
      </section>
      <EndingBanner buttonText="Contact Now" />
    </main>
  );
};

export default ServicePage;
